import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '@/lib/firebase';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { MapPin, Search } from 'lucide-react';

// Lista de cidades disponíveis
const AVAILABLE_CITIES = [
  'Mangaratiba',
  'Angra dos Reis',
  'Paraty',
  'Rio Claro',
  'Itaguaí',
  'Rio de Janeiro',
  'Niterói',
  'São Gonçalo',
  'Duque de Caxias',
  'Nova Iguaçu'
].sort();

export default function CitySelectionPage() {
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const user = auth.currentUser;
    if (!user) {
      navigate('/');
    }
  }, [navigate]);

  const filteredCities = AVAILABLE_CITIES.filter(city =>
    city.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelectCity = (city: string) => {
    navigate('/registration', { state: { city } });
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <div className="max-w-2xl mx-auto space-y-6">
        <div className="text-center">
          <img src="/logo.svg" alt="ConectaComércio" className="h-16 mx-auto mb-6" />
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Selecione sua cidade
          </h1>
          <p className="text-gray-600">
            Escolha sua cidade para encontrar profissionais próximos a você
          </p>
        </div>

        <Card className="p-4">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
            <Input
              type="text"
              placeholder="Buscar cidade..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-10"
            />
          </div>
        </Card>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {filteredCities.map((city) => (
            <Card
              key={city}
              className="p-4 hover:shadow-md transition-shadow cursor-pointer"
              onClick={() => handleSelectCity(city)}
            >
              <div className="flex items-center gap-3">
                <div className="bg-blue-100 p-2 rounded-lg">
                  <MapPin className="h-5 w-5 text-blue-600" />
                </div>
                <div>
                  <h3 className="font-medium text-gray-900">{city}</h3>
                  <p className="text-sm text-gray-500">Rio de Janeiro</p>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {filteredCities.length === 0 && (
          <div className="text-center py-8">
            <p className="text-gray-500">Nenhuma cidade encontrada</p>
          </div>
        )}
      </div>
    </div>
  );
}